<app-modal-header (closeModal)="close()" [isDisabled]="isHttpRequestRunning" [isShowCloseBtn]="isShowCloseBtn" />
@defer (when rateProfile) {
  <app-modal-body>
    <div class="text-center">
      <h1 class="fs-5 fw-semibold mb-0">{{ howWasQuestionKey | translate }}</h1>
      <p class="mb-0">{{ 'WITH' | translate }}</p>
      @if (rateProfile?.profile_image) {
        <div class="rounded-circle mt-3">
          <img
            class="rounded-circle"
            [src]="rateProfile?.profile_image"
            [alt]="rateProfile?.full_name"
            width="60px"
            height="60px"
            fetchpriority="high"
            [appImgErrorFallback]="defaultUserImg"
            loading="lazy"
          />
        </div>
      }
      <p class="fw-semibold mb-0">{{ rateProfile?.full_name }}</p>
      <p class="fw-normal">{{ rateProfile?.company }}</p>

      <p class="fw-normal mb-0">
        {{ 'ON' | translate }} <span class="fw-semibold">{{ rateProfile?.meeting_time }}</span>
      </p>

      <div class="d-flex flex-wrap gap-2 justify-content-center">
        @for (item of [].constructor(5); track $index) {
          <button
            class="btn p-0 border-0"
            type="button"
            (click)="onClickStar($index + 1)"
            [attr.aria-label]="'star-' + $index + 1"
          >
            <i
              class="fs-1"
              [class.ri-star-line]="$index + 1 > rateValue"
              [class.ri-star-fill]="$index + 1 <= rateValue"
              [class.favorited]="$index + 1 <= rateValue"
            >
            </i>
          </button>
        }
      </div>

      <div class="mt-2">
        <button
          type="button"
          class="btn btn-sm btn-danger rounded-3 fw-medium btn-reset-disabled"
          (click)="saveWithPeopleDidNotAttend()"
          [disabled]="isHttpRequestRunning"
        >
          <i class="ri-close-fill"></i>
          {{ didNotAttendKey | translate }}
        </button>
      </div>

      <div class="my-3 mx-5" [class.d-none]="rateValue === -1 || rateValue === 0">
        <textarea
          [(ngModel)]="feedback"
          class="form-control no-resize"
          id="feedback"
          [placeholder]="feedbackPlaceholder | translate"
          rows="3"
        ></textarea>
      </div>

      @if (errorMessage) {
        <p class="text-danger text-center mt-3 mb-0">{{ errorMessage }}</p>
      }
    </div>
  </app-modal-body>
  @if (rateValue > 0) {
    <app-modal-footer classList="d-flex justify-content-center">
      <button
        class="btn btn-primary fw-medium rounded-5 btn-reset-disabled"
        type="button"
        (click)="submit()"
        [disabled]="isHttpRequestRunning"
      >
        @if (isHttpRequestRunning) {
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        }

        @if (source === RateMeetingSource.RATE_SCHEDULE_MEETING && !isLastRated) {
          {{ 'NEXT' | translate }}
        } @else {
          {{ 'SUBMIT_AND_CLOSED' | translate }}
        }
      </button>
    </app-modal-footer>
  }
} @placeholder {
  @if (isShowPlaceholder) {
    <app-modal-body>
      <app-skeleton-general-list [count]="4" />
    </app-modal-body>
  }
}
